export const GET_POSTING_INFO = 'publicador-profesionales/preview/GET_POSTING_INFO';
export const GET_POSTING_INFO_COMPLETED = 'publicador-profesionales/preview/GET_POSTING_INFO_COMPLETED';
export const GET_POSTING_INFO_FAILED = 'publicador-profesionales/preview/GET_POSTING_INFO_FAILED';
export const SET_LOADING = 'publicador-profesionales/preview/SET_LOADING';
export const GET_QUALITY_INFO = 'publicador-profesionales/preview/GET_QUALITY_INFO';
export const GET_QUALITY_INFO_COMPLETED = 'publicador-profesionales/preview/GET_QUALITY_INFO_COMPLETED';
export const GET_QUALITY_INFO_FAILED = 'publicador-profesionales/preview/GET_QUALITY_INFO_FAILED';
